<section class="parameter_cover">
  <div class="file-upload-cover" fxFlexAlign="flex-start" fxLayout="row" fxLayoutGap="20px" fxLayout.xs="column"
    fxLayout.sm="column">
    <div class="file-label">
      <h4 class="font-bold">Upload Parameter</h4>
      <h5 class="font-bold">Allowed file types : CSV</h5>
    </div>
    <div class="file-cover">
      <label for="file-upload1" class="custom-file-upload">Browse</label>
      <mat-error>{{uploadErrorText}}</mat-error>
      <input id="file-upload1" (change)="readFile($event)" type="file" accept=".{{fileType}}">
    </div>
    <div class="filename">
      @if (uploadFileName) {
        <h4><span class="wordBreak">{{uploadFileName}}</span></h4>
      }
      @if (uploadFileName) {
        <button mat-button type="button" color="primary" (click)="cancelFile()">
          <mat-icon>highlight_off</mat-icon>
        </button>
      }
    </div>
    <div class="template-download">
      <h4 (click)="downloadTemplate()">Download Template</h4>
    </div>
  </div>
</section>